//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';
import MdmVideo from '~/components/atoms/Global/MdmVideo.vue';
export default {
  name: 'TrendBlockDispatch',
  components: {
    MdmVideo
  },
  props: {
    src: {
      type: Object,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    video: {
      type: String,
      default: ''
    },
    playerColor: {
      type: String,
      default: 'white'
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      default: ''
    },
    buttonUrl: {
      type: String,
      default: ''
    },
    first: {
      type: Boolean,
      default: false
    },
    released: {
      type: Boolean,
      default: false
    },
    dateLabel: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    backgroundColorDate: {
      type: String,
      default: '#c4a181'
    },
    imgText: {
      type: String,
      default: ''
    },
    tracking: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      mobile: true,
      desktop: true,
      hoverState: false
    };
  },

  computed: {
    colorBtn() {
      if (this.desktop) {
        return this.hoverState ? this.backgroundColor : '#F8F8F8';
      }

      return this.backgroundColor;
    }

  },

  mounted() {
    this.mobile = this.isMobile();
    this.desktop = this.isDesktop();
  },

  methods: {
    updateBtnHover(isHover) {
      this.hoverState = isHover;
    }

  }
};